/**
 *
 * @param $httpProvider
 */
export function httpProvider(
  $httpProvider
) {

  'ngInject';

  let unauthorizedInterceptor = (
    $q,
    $injector
  ) => {
    return {
      responseError: (response) => {
        if( response.status === 401 ){
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          $injector.get('$state').go('signin');
        }
        return $q.reject(response);
      }
    }
  };

  let forbiddenInterceptor = (
    $q,
    $injector
  ) => {
    'ngInject';
    return {
      responseError: (response) => {
        if (response.status === 403) {
          $injector.get('$state').go('forbidden');
        }
        return $q.reject(response);
      }
    };
  };

  let notfoundInterceptor = (
    $q,
    $injector
  ) => {
    return {
      responseError: (response) => {
        if( response.status === 404 ){
          $injector.get('$state').go('notfound');
        }
        return $q.reject(response);
      }
    }
  };

  $httpProvider.interceptors.push(
    unauthorizedInterceptor,
    notfoundInterceptor
  );

}


/** WEBPACK FOOTER **
 ** ./frontend/config/httpProvider.config.js
 **/